
  import { Component } from 'vue-property-decorator'

  import BaseIcon from './BaseIcon.vue'

  @Component({
    name: 'CopyIcon',
  })
  export default class extends BaseIcon {}
